module.exports = __webpack_public_path__ + "static/img/CgoRDGREg0-AGX9tAATCO3ju9Sk425.1348028.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/CgoRDGREg0-AGX9tAATCO3ju9Sk425.jpg
// module id = zJmY
// module chunks = 73